import {Component, Input, OnInit} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '../shared/question-base';
import { APPCONFIG } from "../../../config";

@Component({
  selector: 'app-dynamic-form-question',
  templateUrl: './dynamic-form-question.component.html'
})
export class DynamicFormQuestionComponent implements OnInit{
  @Input() question: QuestionBase<any>;
  @Input() form: FormGroup;
  AppConfig: any;

  get isValid() {
    return this.question.disabled ? true : this.form.controls[this.question.key].valid;
  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/dynamic-form/dynamic-form-question/dynamic-form-question.component.ts